import { InquiryDetailsComponent } from './inquiry-details/inquiry-details.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddComponent } from './add/add.component';
import { DeleteComponent } from './modals/delete/delete.component';
import { EditComponent } from './edit/edit.component';
import { ListComponent } from './list/list.component';
import { DetailComponent } from './detail/detail.component';

const routes: Routes = [
  { path: 'edit/:type/:id', component: EditComponent },
  
  { path: 'view/:type/:id', component: DetailComponent },

  { path: 'add/:type/:category_id', component: AddComponent },
  { path: 'add/:type', component: AddComponent },


  { path: 'inquiries/details/:id', component: InquiryDetailsComponent },

  { path: 'delete/:type/:id', component: DeleteComponent },
  { path: ':type', component: ListComponent },
  { path: 'list/:type/:category_id', component: ListComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CoreContentManagerRoutingModule {}
